module.exports = __webpack_public_path__ + "static/media/banner-clients-06.da5b6cec.jpg";